import React from 'react'
import Marquee from './Marquee'

const CLIENTS = [
  'Campo Real',
  'UCP',
  'Univale',
  'Colégio Panamericano',
  'SESC',
  'Cresol',
  'Ictus',
  'Bacana Motors',
  'BSB Construtora',
  'Empório Maziero',
  'LB Store',
  'Nadi Modas',
  'Restaurante Bilk',
  'Macias & Cruz',
  'Freitas & Goedert',
  'Formigão Tintas',
  'Auto Vidro Shop',
  'Ângelo H. Landgraf',
  'Aprovale',
  'BBQ Valley',
  'Bilk Carnes',
  'Bode Fest',
  'Campos Verdes',
  'Cheiro Verde',
  'Cintras Móveis',
  'Cissa Papelária e Presentes',
  'Clínica Padova',
  'Comacol',
  'Cooperfavi',
  'Espetinhos Bilk',
  'Fernando Teigão',
  'Galpão Crioulo',
  'Gela Boca',
  'Gerencial',
  'Grupo Center - Ki Barato',
  'Kamila Bernardo',
  'Líder Cred',
  'Luciane Crozetta',
  'MB Tax and Business',
  'Moda Ki Barato',
  'Moviorto',
  'OAB',
  'Porto Por Ti',
  'Quiosque Sírio',
  'Renata Biasim',
  'Tânia Barbosa',
  "Tec's Tintas",
  'Thays Marlys',
  'VagaRH',
  'W.Wess Calçados',
]

function PartnerLogos() {
  const rowB = CLIENTS.slice().reverse()

  return (
    <section className='section-h-half overflow-hidden border-y border-dorac-border bg-white'>
      <div className='container mx-auto mb-8 px-4 text-center'>
        <span className='section-eyebrow text-base tracking-widest md:text-lg'>Marcas que confiaram na Dorac</span>
      </div>

      <div className='flex flex-col gap-8'>
        <Marquee items={CLIENTS} speed={40} />
        <Marquee items={rowB} reverse speed={40} />
      </div>
    </section>
  )
}

export default PartnerLogos
